import React, { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import '../../../../../assets/scss/preview.css';
import { safObjectHelper } from '../../../../../utils/SafObjectHelper.ts';
import { companyApi } from '../../../../../modules';
import { codeApi } from '../../../../../api/code.api.ts';

interface IProps {
  ref?: any;
  formCode?: string;
  section?: any;
  data: any;
}

const View = (props: IProps) => {
  const [companyName, setCompanyName] = useState<any>();
  const [disciplineName, setDisciplineName] = useState<any>();
  const [manpowerOptions, setManpowerOptions] = useState<any>([]);
  useEffect(() => {
    codeApi.getManpowerCodeList().then((list) => {
      setManpowerOptions(list);
    });
  }, []);
  useEffect(() => {
    if (!props.data?.companyId) return;
    companyApi.getCompanyDetail({ companyId: props.data.companyId }).then((res) => {
      setCompanyName(res.resultObject.companyName);
    });
  }, [props.data?.companyId]);
  useEffect(() => {
    if (!props.data?.companyId) return;
    codeApi.getCodeDetail(props.data.disciplineCd).then((res) => {
      setDisciplineName(res.codeName);
    });
  }, [props.data?.disciplineCd]);
  return (
    <div>
      <table className={'preview-table'}>
        <colgroup>
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'5%'} />
          <col width={'10%'} />
          <col width={'5%'} />
          <col width={'10%'} />
          <col width={'5%'} />
          <col width={'20%'} />
        </colgroup>
        <tbody>
          <tr>
            <th>Subcontractor</th>
            <td colSpan={5}>{props.data?.subcontractor}</td>
            <th colSpan={2}>Mark location on the drawing (To be included alternative Route)</th>
          </tr>
          <tr>
            <th>Task Description</th>
            <td colSpan={5} style={{ height: '4rem' }}>
              {props.data?.description}
            </td>
            <th rowSpan={3} className={'saf-border-bottom-none'}>
              Location / Area
            </th>
            <td
              rowSpan={3}
              className={'saf-border-bottom-none saf-td-center'}
              style={{
                backgroundImage: 'url(' + props.data?.locationImage + ')',
                backgroundSize: 'cover'
              }}
            >
              &nbsp;
            </td>
          </tr>
          <tr>
            <th rowSpan={2} className={'saf-border-bottom-none'}>
              Expected Closure
              <br />
              Period
            </th>
            <th>Date</th>
            <th>From</th>
            <td className={'saf-td-center'}>
              {safObjectHelper.formatDate(props.data?.validStartTime)}
            </td>
            <th>To</th>
            <td className={'saf-td-center'}>
              {safObjectHelper.formatDate(props.data?.validEndTime)}
            </td>
          </tr>
          <tr>
            <th>Time</th>
            <th>From</th>
            <td className={'saf-td-center'}>
              {safObjectHelper.formatTime(props.data?.validStartTime)}
            </td>
            <th>To</th>
            <td className={'saf-td-center'}>
              {safObjectHelper.formatTime(props.data?.validEndTime)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default View;
